module.exports = __webpack_public_path__ + "static/theia-gravidez-print1-705c53ead61e8ab26eb07a57625bff53.png";